<div class="item-container d-flex flex-column">
  <div class="item-header">
    <h6 class="text-center">{{"Add Multiple User"|translate}}</h6>
    <div class="edit-icons" mat-dialog-close>
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content">
    <div class="my-2" *ngIf="dialogData.dataType=='csv'"><span class="primary-color text-semibold">Note:</span>
      <span class="note-txt ms-2">The presence of a user in red indicates that the user already exists. </span>
    </div>
    <table class="mt-4" mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 normal-td">
      <ng-container matColumnDef="No.">
        <th mat-header-cell *matHeaderCellDef> No. </th>
        <td mat-cell *matCellDef="let element;let i=index">{{i+1}}</td>
      </ng-container>

      <ng-container matColumnDef="first_name">
        <th mat-header-cell *matHeaderCellDef class="user"> First Name </th>
        <td mat-cell *matCellDef="let element">
          <input type="text" class="form-control" placeholder="First Name" [(ngModel)]="element.f_n">
        </td>
      </ng-container>
      <ng-container matColumnDef="last_name">
        <th mat-header-cell *matHeaderCellDef> Last Name</th>
        <td mat-cell *matCellDef="let element">
          <input type="text" class="form-control" placeholder="Last Name" [(ngModel)]="element.l_n">
        </td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef> Email</th>
        <td mat-cell *matCellDef="let element">
          <input type="text" class="form-control" placeholder="Email" [(ngModel)]="element.el">
        </td>
      </ng-container>
      <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef> Invitation Message</th>
        <td mat-cell *matCellDef="let element">
          <textarea name="" class="form-control" id="" cols="10" rows="2" [(ngModel)]="element.msg"></textarea>
      </ng-container>
      <ng-container matColumnDef="password">
        <th mat-header-cell *matHeaderCellDef> Password </th>
        <td mat-cell *matCellDef="let element">
          <input type="password" class="form-control" placeholder="Enter password" [(ngModel)]="element.pwd">
        </td>
      </ng-container>
      <ng-container matColumnDef="confirm_password">
        <th mat-header-cell *matHeaderCellDef> Confirm Password</th>
        <td mat-cell *matCellDef="let element">
          <input type="password" class="form-control" placeholder="Enter confirm password" [(ngModel)]="element.c_pwd">
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> Action</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div (click)="onDeleteItem(i)" class="cursor-pointer">
            <img src="assets/images/icons/delete.png" class="img-fluid" alt="">
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        [ngClass]="row.el_e =='This user already exist.' ? 'course-assign':''"></tr>
    </table>
    <div class="m-auto my-4 text-center">
      <button mat-raised-button color="warn" class="auth-form-btn  success-btn ms-3" type="submit"
        *ngIf="dialogData.dataType!='csv'" (click)="onAddMore()"><i class="fas fa-plus me-2"></i>Add More</button>
    </div>
  </div>
  <div class="row item-footer">
    <div class="col-md-6  offset-md-6">
      <div class="text-left " style="text-align: right;">
        <mat-error *ngIf="errorMessage">{{errorMessage}}</mat-error>
      </div>
      <div class="d-flex justify-content-center align-items-center m-container">
        <button type="button"
          class="auth-form-btn btn-outline-primary d-flex align-items-center justify-content-center my-3 me-3"
          (click)="onCancel()">
          {{"Cancel" |translate}}</button>
        <button mat-raised-button color="primary" class="auth-form-btn my-3 no-sh-btn" type="submit"
          (click)="onSave()">{{"Save"|translate}}</button>
      </div>
    </div>
  </div>
</div>

<app-loading-spinner></app-loading-spinner>